import { IMeeting, shortMonths } from '@utils';
import { format, isToday, isTomorrow, isYesterday } from 'date-fns';
import React, { FC, useCallback, useMemo } from 'react';
import { Button } from '../button';

interface FilteredMeetingsProps {
  meetings: IMeeting[];
  onClickShowMore: () => void;
  onClickMeeting: (meeting: IMeeting) => void;
  onReset: () => void;
}

export const FilteredMeetingsList: FC<FilteredMeetingsProps> = ({ meetings, onClickShowMore, onClickMeeting, onReset }) => {

  const clippedFilteredMeetings = useMemo(() =>
    meetings.length > 5
      ? meetings.slice(0, 5)
      : meetings
    , [meetings.length]);

  const getDateString = useCallback((startDate: Date) => {
    let datePoint;
    if (isToday(startDate)) datePoint = 'Сегодня';
    else if (isTomorrow(startDate)) datePoint = 'Завтра';
    else if (isYesterday(startDate)) datePoint = 'Вчера';
    else datePoint = `${startDate.getDate()} ${shortMonths[startDate.getMonth()]}. ${startDate.getFullYear()}`;
    return `${datePoint} ${format(startDate, 'HH:mm')}`;
  }, []);

  return (
    <div className="filtered-meetings">
      {!!meetings.length
        ? clippedFilteredMeetings.map(meeting => (
          <div
            className="filtered-meeting"
            key={`meeting-${meeting.id}-${meeting.startDate.toLocaleString()}`}
            onClick={() => onClickMeeting(meeting)}
          >
            <div className="info">
              <div
                className="circle"
                style={{ backgroundColor: meeting.calendarColor }}
              />
              <div className="name">{meeting.meetingName}</div>
            </div>
            <div className="date">
              {getDateString(meeting.startDate)}
            </div>
          </div>
        ))
        : <div className="placeholder">Ничего не найдено</div>
      }
      <div className="actions">
        {meetings.length > 5 && (
          <div
            className='show-more'
            onClick={onClickShowMore}
          >
            Еще...
          </div>
        )}
        <div className="reset">
          <Button title="Сбросить" onClick={onReset} className="outlined small" />
        </div>
      </div>
    </div>
  );
};